export const ROLES = ["admin", "manager", "cashier", "waiter", "kitchen"] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  admin: "Administrator",
  manager: "Manager",
  cashier: "Kasjer",
  waiter: "Kelner",
  kitchen: "Kuchnia",
};

export const PERMISSIONS = [
  "order.create",
  "order.edit",
  "order.send",
  "item.void", // usunięcie pozycji, której kuchnia jeszcze nie dostała
  "item.void_sent", // storno pozycji już wysłanej do kuchni
  "order.cancel",
  "order.transfer",
  "discount.apply",
  "payment.take",
  "order.close",
  "shift.manage",
  "reports.view",
  "admin.manage",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const STAFF_BASE: Permission[] = ["order.create", "order.edit", "order.send", "item.void", "payment.take", "order.close"];

export const DEFAULT_ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  admin: [...PERMISSIONS],
  manager: PERMISSIONS.filter((p) => p !== "admin.manage"),
  cashier: [...STAFF_BASE, "order.transfer", "discount.apply"],
  waiter: [...STAFF_BASE, "order.transfer"],
  kitchen: [],
};

/** Maksymalny rabat procentowy, który rola może nadać bez managera. */
export const DEFAULT_MAX_DISCOUNT_PERCENT: Record<Role, number> = {
  admin: 100,
  manager: 100,
  cashier: 10,
  waiter: 0,
  kitchen: 0,
};
